import styled from 'styled-components';

export const OverflowContainer = styled.div`
	max-height: calc(96vh - 21rem);
	overflow-y: auto;
`;
